import { HomeData } from "../types/home";
import { ApiResponse } from "../types/api";
import { api } from "./api";

export const homeService = {
  getHomeData: async (): Promise<HomeData> => {
    const response = await api.get<ApiResponse<HomeData>>("/api/home");
    return response.data.data;
  },
};
